<template>
  <j-modal
    :maskClosable="false"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="1200"
    @cancel="handleCancel"
    @ok="handleOk"
    switchFullscreen
  >
    <yw-daily-overhaul-task-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm" />
    <template slot="footer">
      <a-button @click="handleOk" type="primary" v-if="!disableSubmit">保存</a-button>
      <a-button @click="handleFinish" type="primary" v-if="!disableSubmit">直接完成</a-button>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
  </j-modal>
</template>

<script>

  import YwDailyOverhaulTaskForm from './YwDailyOverhaulTaskForm'

  export default {
    name: 'YwDailyOverhaulTaskModal',
    components: {
      YwDailyOverhaulTaskForm
    },
    data () {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.$refs.devBpbjLeadoutRecordList.getData(record.id)
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
      },
      handleFinish () {
        this.$refs.realForm.handleFinish();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>


</style>